export default __webpack_public_path__ + "static/media/darkPurpleHelm.43b9dcd3.svg";